/**
 * Seam between the employment-profile API and the local persisted store, the
 * same arrangement the schedule and the floor planner use.
 *
 * - true (default): employment profiles are read from and written to
 *   `/restaurants/{restaurantId}/employment-profiles`, which the backend now
 *   implements.
 * - false: the feature falls back to the persisted zustand store it used while
 *   the backend had nowhere to put employment data, so rolling the endpoint
 *   back degrades the feature instead of breaking the page.
 *
 * Components never branch on this, they consume `useEmploymentProfiles`,
 * which returns the same shape in both modes.
 */
export const EMPLOYMENT_USE_API = true

/** Backend path, relative to `/restaurants/{restaurantId}`. */
export const EMPLOYMENT_PROFILES_ENDPOINT = '/employment-profiles'
